import { PercentOutlineIcon } from './PercentOutlineIcon';

/**
 * author: MC的wither菌
 * id 0625AC7C-AD52-4221-8F53-A9AE6DAA57BD
 * name percent-outline
 * version: 4.7.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/percent-outline.svg
 * tags
 * - Math 
 * - Shopping 
 */
export const DiscountOutlineIcon = PercentOutlineIcon;
export default DiscountOutlineIcon